import { Colors } from "constants/Colors";
import { css } from "styled-components";

export const BottomBarCTAStyles = css`
  :hover {
    background-color: ${Colors.GRAY_100};
  }
`;
